import { useEffect } from 'react';
import getBridge from '@/jsbridge';

export interface IShare {
  title?: string;
  desc?: string;
  imgUrl?: string;
  link?: string;
}

const useShare = ({
  title,
  desc,
  imgUrl,
  link = '',
}: IShare) => {
  const setShareInfo = (currentUrl: string) => {
    getBridge(link || currentUrl).then((Bridge: any) => {
      Bridge.setShareInfo({
        desc,
        title,
        imgUrl,
        link,
      });
    });
  };

  useEffect(() => {
    setShareInfo(window.location.href);
  }, [title, desc, imgUrl, link]); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useShare;
